// Add this to your inputsCustomizations object
export const PaperCusomizations = {
  // ... your existing customizations ...
  
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }) => ({
        // backgroundColor: '#ffffff !important',
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.background.paper, // Optional: different background in dark mode
        }),
      }),
    },
  },
  
  // ... rest of your customizations ...
};